import { render, staticRenderFns } from "./previewArchives.vue?vue&type=template&id=320b3bee&scoped=true"
import script from "./previewArchives.vue?vue&type=script&lang=js"
export * from "./previewArchives.vue?vue&type=script&lang=js"
import style0 from "./previewArchives.vue?vue&type=style&index=0&id=320b3bee&prod&lang=stylus&scoped=true"
import style1 from "./previewArchives.vue?vue&type=style&index=1&id=320b3bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b3bee",
  null
  
)

export default component.exports